import PropTypes from 'prop-types';
import { styled, useTheme } from '@mui/material/styles';
import { Box, Drawer, useMediaQuery } from '@mui/material';
import PerfectScrollbar from 'react-perfect-scrollbar';

import MenuList from './MenuList';
import { drawerWidth, collapsedDrawerWidth } from 'utils/constant';

const DrawerStyled = styled(Drawer, {
    shouldForwardProp: (prop) => prop !== 'open'
})(({ theme, open }) => ({
    width: open ? drawerWidth : collapsedDrawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    '& .MuiDrawer-paper': {
        width: open ? drawerWidth : collapsedDrawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.shorter
        }),
        overflowX: 'hidden',
        background: theme.palette.common.black,
        color: theme.palette.text.primary,
        borderRight: `1px solid ${theme.palette.divider}`,
        [theme.breakpoints.up('md')]: { top: 68 }
    }
}));

const Sidebar = ({ drawerOpen, drawerToggle, window }) => {
    const theme = useTheme();
    const upMd = useMediaQuery(theme.breakpoints.up('md'));

    const container = window !== undefined ? () => window.document.body : undefined;

    // active width drives the outer nav box so layout doesn’t jump
    const activeWidth = drawerOpen ? drawerWidth : collapsedDrawerWidth;

    return (
        <Box component="nav" sx={{ width: { xs: 0, md: activeWidth }, flexShrink: { md: 0 } }}>
            <DrawerStyled
                container={container}
                variant={upMd ? 'permanent' : 'temporary'}
                anchor="left"
                open={drawerOpen}
                onClose={drawerToggle}
                ModalProps={{ keepMounted: true }}
            >
                <PerfectScrollbar
                    component="div"
                    style={{
                        height: !upMd ? 'calc(100vh - 56px)' : 'calc(100vh - 88px)',
                        paddingLeft: drawerOpen ? 16 : 8,
                        paddingRight: drawerOpen ? 16 : 8
                    }}
                >
                    <MenuList open={drawerOpen} />
                </PerfectScrollbar>
            </DrawerStyled>
        </Box>
    );
};

Sidebar.propTypes = {
    drawerOpen: PropTypes.bool,
    drawerToggle: PropTypes.func,
    window: PropTypes.object
};

export default Sidebar;